import { globalActions } from "../../store/reducers/globalReducer";
import axios from "axios";
import { store } from '../../store'

export function groupBy(xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}

function costPerUnit(n, object) {
    //n.objCode = object.code
    n.area = n.sum / object.area
    n.area2 = n.sum / object.area2
    n.value = n.sum / object.value
    n.power = n.sum / object.power
    if (n.children) {
        n.children.forEach(m => {
            costPerUnit(m, object)
        })
    }
}

export function setUnitCosts(ptmTree, objects) {
    ptmTree.forEach((n, i, arr) => {
        let object = objects.find(obj => obj.id === n.obj)
        if (object) {
            n.objCode = object.code
            n.regionId = object.regionId
            n.regionName = object.regionName
            n.zoneCode = object.zoneCode
            costPerUnit(n, object)
        }
    })
    return ptmTree;
}

export function setObjIndex(ptmTree, objects, vat) {
    let group = groupBy(ptmTree, 'objCode')
    let keys = Object.keys(group)
    let indexed = []
    let contractorOtherCost = 0
    let customerCost = 0
    let vatCost = 0
    keys.forEach((n, i) => {
        let pts = group[n]
        let object = objects.find(obj => obj.code === n)
        if (object) {
            let sum = pts.map(n => n.price).reduce((partialSum, a) => partialSum + a, 0)
            if (object.priceContractor) {
                let ratioContractor = object.priceContractor / object.price
                contractorOtherCost += ratioContractor * sum //другие затраты подрядчика для данного объекта
                //let percentContractor = ratioContractor * 100
                //contractorOtherCost = { key: object.id + '_9', objCode: n, code: '9', price: ratioContractor * sum, name: `Другие затраты подрядчика: ${percentContractor.toFixed(2)}%` }
            }
            if (object.priceCustomer) {
                let ratioCustomer = object.priceCustomer / object.price
                customerCost += ratioCustomer * sum//затраты заказчика для данного объекта
                //let percentCustomer = ratioCustomer * 100
                //customerCost = { key: object.id + '_10', objCode: n, code: '10', price: ratioCustomer * sum, name: `Затраты заказчика: ${percentCustomer.toFixed(2)}%` }
            }
            if (vat) {
                if (object.nds) {
                    let ratioVat = object.nds / object.price
                    vatCost += ratioVat * sum//ндс для стоимостного метода конструктора для данного объекта
                }
            }
        }
        pts = pts.map(n => (setIndex(n, i)))
        indexed.push(...pts)
    })
    let contractorOtherRecord = {
        key: 999 + '_9',
        code: '9',
        price: contractorOtherCost,
        name: `Другие затраты подрядчика:`
    }
    let customerRecord = { key: 999 + '_10', code: '10', price: customerCost, name: `Затраты заказчика:` }
    indexed.sort((a, b) => a.code > b.code ? 1 : -1)
    groupSameCode2(indexed)
    indexed.push(contractorOtherRecord)
    indexed.push(customerRecord)
    if (vat) {
        let vatRecord = { key: 999 + '_vat', code: '', price: vatCost, name: `НДС:` }
        indexed.push(vatRecord)
    }
    return indexed
}

function groupSameCode2(ptmTree) {
    let group = groupBy(ptmTree, 'code')
    let keys = Object.keys(group)
    keys.forEach((n, i) => {
        let pts = group[n]
        let length = pts.length
        if (length > 1) {
            let subtotal = pts.map(n => n.price).reduce((partialSum, a) => partialSum + a, 0)
            let ptm = pts[length - 1]
            const index = ptmTree.findIndex(p => p.key === ptm.key)
            let subtotalRecord = {
                key: 999 + '_total_' + n,
                code: n,
                price: subtotal,
                name: `Итоговая сумма по ПТМ ${n}`
            }
            ptmTree.splice(index + 1, 0, subtotalRecord)
        }
    })
}

function setIndex(n, i) {
    n.index = i
    if (n.children) {
        n.children.forEach(m => {
            setIndex(m, i)
        })
    }
    return n
}

export function recalculate(ptmList, objects) {
    objects.forEach(ob => {
        for (let i = 5; i > 2; i--) {
            let ptmObjList = ptmList.filter(m => m.obj === ob.id)
            let checkedLevel = ptmObjList.filter(m => m.level === i)
            if (checkedLevel.length > 0) {
                let group = groupBy(checkedLevel, 'parentId')
                let parents = ptmObjList.filter(n => group.hasOwnProperty(n.rePtmId)).map(el => ({ ...el }))//находим для них parent-ов
                parents.forEach((item, i, arr) => {
                    let children = group[item.rePtmId]
                    let sum = children.map(n => n.sum).reduce((partialSum, a) => partialSum + a, 0)
                    let index = ptmList.findIndex(n => n.key === item.key)
                    if (item.id === 0) {
                        ptmList[index].sum = sum
                    } else {
                        ptmList[index].sum += sum
                    }
                })
            }
        }
    })
    return ptmList;
}

export function getParents(ptmList, checkedKeys) {
    const checked = ptmList.filter(r => checkedKeys.includes(r.key))
    for (let i = 5; i > 1; i--) {
        let checkedLevel = checked.filter(m => m.level === i)
        if (checkedLevel.length > 0) {
            let group = groupBy(checkedLevel, 'parentId')
            let parents = ptmList.filter(n => group.hasOwnProperty(n.rePtmId)).map(el => ({ ...el }))//находим для них parent-ов
            parents.forEach((item, i, arr) => {
                //let children = group[item.rePtmId]
                //let sum = children.map(n => n.sum).reduce((partialSum, a) => partialSum + a, 0)
                let parent = checked.find(n => n.key === item.key)
                if (!parent) {
                    //item.sum = sum
                    checked.push(item)
                }
            })
        }
    }
    return checked;
}

export function treeFromList(ptmList, level) {
    let treeData = ptmList?.filter(n => n.level === level).map(item => {
        let check = item.code !== '9' && item.code !== '10'
        let element = {
            ...item,
            title: `${item.name} (${item.code})`,
            disableCheckbox: item.code === '9',
            checkable: check,
        }
        let children = getChildren(ptmList, item, check)
        if (children.length > 0) {
            element.children = children
        }
        return element
    })
    treeData.sort((a, b) => {//сортрировка для дерева ПТМ-ов объекта-донора
        return a.code.localeCompare(b.code, undefined, {
            numeric: true,
            sensitivity: 'base'
        });
    })
    return treeData;
}

export function treeFromListResource(ptmList, level) {
    let treeData = ptmList?.filter(n => n.level === level).map(item => {
        let element = {
            ...item,
        }
        let resources = {
            ptmConstructionMaterialPrices: [],
            ptmMechanismPrices: [],
            ptmEquipmentPrices: []
        }
        if (element.resources) {
            resources = element.resources
        }
        let children = getChildrenResource(ptmList, item, resources)
        if (children.length > 0) {
            element.children = children
        }
        element.resources = resources
        return element
    })
    return treeData;
}

//строит иерархию потомков и аккумулирует их ресурсы в ПТМ-ы 2-го уровня
function getChildrenResource(state, item, resources) {
    return state?.filter(n => n.parentId !== null && n.parentId === item.rePtmId && n.obj === item.obj)
        .map((el) => {
            let element = {
                ...el,
            }//одинаковые ресурсы по коду должны быть сведены к одной записи для ПТМ-ов 2-го уровня
            if (element.resources) {
                element.resources.ptmConstructionMaterialPrices.forEach(n => {
                    let index = resources.ptmConstructionMaterialPrices.findIndex(p => p.codeKKM === n.codeKKM)
                    if (index >= 0) {
                        let smt2 = resources.ptmConstructionMaterialPrices[index]
                        smt2.value += n.value
                    } else {
                        resources.ptmConstructionMaterialPrices.push({ ...n })
                    }
                })
                element.resources.ptmMechanismPrices.forEach(n => {
                    let index = resources.ptmMechanismPrices.findIndex(p => p.code === n.code)
                    if (index >= 0) {
                        let smh2 = resources.ptmMechanismPrices[index]
                        smh2.value += n.value
                    } else {
                        resources.ptmMechanismPrices.push({ ...n })
                    }
                })
                element.resources.ptmEquipmentPrices.forEach(n => {
                    let index = resources.ptmEquipmentPrices.findIndex(p => p.code === n.code)
                    if (index >= 0) {
                        let seq2 = resources.ptmEquipmentPrices[index]
                        seq2.value += n.value
                    } else {
                        resources.ptmEquipmentPrices.push({ ...n })
                    }
                })
            }

            let children = getChildrenResource(state, el, resources)
            if (children.length > 0) {
                element.children = children
            }
            return element
        })
}

function getChildren(state, item, check) {
    return state?.filter(n => n.parentId !== null && n.parentId === item.rePtmId && n.obj === item.obj)
        .map((el) => {
            let element = {
                ...el,
                title: `${el.name} (${el.code})`,
                //checkable: el.level === 5 ? false : true,
                //disableCheckbox: el.level === 4 ? true : false,
                checkable: check,
            }
            let children = getChildren(state, el, check)
            if (children.length > 0) {
                element.children = children
            }
            return element
        })
}

export function delChildren(list, ptm) {
    let updated = list.filter(n => n.key !== ptm.key)
    if (ptm.rePtmId) {
        let children = list.filter(n => n.parentId === ptm.rePtmId && n.obj === ptm.obj)
        if (children.length > 0) {
            children.forEach(item => {
                updated = delChildren(updated, item)
            })
        }
    }
    return updated
}

export function delParents(list, ptm) {
    let parentId = ptm.parentId
    let updated = [...list]
    if (parentId) {
        let siblings = list.filter(n => n.parentId === parentId && n.obj === ptm.obj)
        if (siblings.length === 0) {
            let parent = list.find(n => n.rePtmId === parentId && n.obj === ptm.obj)
            updated = updated.filter(n => n.obj !== ptm.obj || n.rePtmId !== parentId)
            if (parent?.parentId) {
                updated = delParents(updated, parent)
            }
        }
    }
    return updated
}

export function remove(key, project, setProject) {
    const ptmToDel = project.ptms.find(n => n.key === key)
    let ptms = delChildren(project.ptms, ptmToDel)
    ptms = delParents(ptms, ptmToDel)
    let ptmObjectId = ptmToDel.obj
    let isOtherPtm = ptms.some(n => n.obj === ptmObjectId)
    let objects = [...project.objects]
    if (!isOtherPtm) {
        let index = objects.findIndex((obj => obj.id === ptmObjectId))
        objects.splice(index, 1)
    }
    ptms = recalculate(ptms, objects)
    setProject({ ptms, objects })
}

export const updatePtmResourcesPrice = (objectIds, ptms, formState, sucFunction) => {
    let correction = formState.correction
    let costIndex = formState.costIndex
    ptms.forEach(c => {//лимитированные затраты
        const lim = c.limited?.value
        if (lim) {
            c.sum = correction === 1 ? lim * costIndex : lim * correction
        }
    })
    let count = 0
    objectIds.forEach(obj => {
        let objectPtms = ptms.filter(n => n.obj === obj)
        let ptmIds = objectPtms.filter(n => n.priceDetails != null && n.rePtmId != null).map(m => m.rePtmId)
        let ptmProjectIds = objectPtms.filter(n => n.priceDetails?.rePtmProjId != null).map(m => m.priceDetails.rePtmProjId)
        if (ptmIds.length > 0 || ptmProjectIds.length > 0) {
            count++
            store.dispatch(globalActions.setLoadingVisible(true))
            axios.post("/constructor/ptmResourcesPrice", {
                analogObjectId: obj,
                month: formState.month,
                year: formState.year,
                regionId: formState.regionId,
                zoneId: formState.zoneId,
                vat: !formState.vat,//если ндс не выбран, то получаем материалы и оборудование с ндс
                ptmIds: ptmIds,
                ptmProjectIds: ptmProjectIds,
                //costIndex: formState.costIndex
            }).then(res => res.data)
                .then(res => {
                    res.forEach(n => {
                        let index
                        if (n.isMainPtm) {
                            index = ptms.findIndex(ch => ch.rePtmId === n.id)
                        } else {
                            index = ptms.findIndex(ch => ch.priceDetails?.rePtmProjId === n.id)
                        }

                        let ptm = ptms[index] //редактируемый ПТМ
                        let pd = ptm.priceDetails

                        pd.pay = correction === 1 ? pd.pay * costIndex : pd.pay * correction //заработная плата
                        pd.oo = correction === 1 ? pd.oo * costIndex : pd.oo * correction    //ОХР и ОПР
                        pd.pp = correction === 1 ? pd.pp * costIndex : pd.pp * correction    //плановая прибыль

                        pd.omach = n.omach
                        pd.matt = n.matt
                        pd.trm = n.trm
                        pd.eqp = n.eqp
                        pd.tre = n.tre

                        ptm.sum = pd.pay + pd.omach + (pd.matt + pd.trm) + (pd.eqp + pd.tre) + (pd.oo + pd.pp)
                        ptm.resources = n.resources
                    })
                })
                .catch(_ => {
                    //Notifications.errorNotice(t('Не удалось получить цены на дату формирования'), null, 10)
                })
                .finally(() => {
                    sucFunction(ptms)
                    if (--count === 0) {
                        store.dispatch(globalActions.setLoadingVisible(false))
                    }
                })
        } else {//если не было запроса на обновление данных
            sucFunction(ptms)
        }
    })
}

export function getRefArea(code) {
    let x = null
    switch (code) {
        case (1):
            x = 'power'
            break
        case (2):
        case (4):
            x = 'area'
            break
        case (3):
        case (5):
            x = 'area2'
            break
        case (6):
            x = 'value'
            break
    }
    return x
}

//цвета для выделения ПТМ-ов, относящихся к одному объекту-аналогу
//key - index цвета, value - название класса для background style color, см. style.css
export const colors = {
    0: '#ffffcc',
    1: '#f1f7e7',
    2: '#f1fee1',
    3: '#fffff0',
    4: '#ffcc66',
    5: '#ccff',
    6: '#ffcc99',
    7: '#ccffff',
    8: '#ddd'
}